

export default {
    vi : {
        header: 'Lấy lại mật khẩu',
        description: 'Nhập email của bạn để nhận mã xác thực lấy lại mật khẩu',
        email: 'Nhập email của bạn',
        invalidEmail: 'Email không hợp lệ',
        login: 'Quay lại đăng nhập'
    },
    en: {
        header: 'Reset password',
        description: 'Enter your email to receive verification code for reseting your password',
        email: 'Enter your email',
        invalidEmail: 'Email is invalid',
        login: 'Back to login'
    }
};
